import { render, staticRenderFns } from "./ChartsPartial.vue?vue&type=template&id=6c2fa18d&"
import script from "./ChartsPartial.vue?vue&type=script&lang=js&"
export * from "./ChartsPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports